import { CircularProgress, Stack, Theme, useMediaQuery } from '@mui/material';
import { MainTextSearchInput, Page, Space } from 'components';
import { BullDetails } from 'components/Main';
import { Store } from 'rdx';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { bulls as bullService } from 'services';
import { Bull } from 'types';
import utils from 'utils';
import Breeds from './Breeds';
import BullList from './BullList';
import Initial from './Initial';

const Main: FC = () => {
  
  const { scope, items } = useSelector((store: Store) => store);

  const [ currentBull, setCurrentBull ] = useState<Bull | null>(null);
  const [ bullLoading, setBullLoading ] = useState(false);
  const gtMd = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  useEffect(() => {
    if (scope.bull === null) {
      setCurrentBull(null);
      return;
    }

    let active = true;
    setBullLoading(true);

    bullService.getByCrvCode(scope.bull)
      .then((bull) => {
        if (active) setCurrentBull(bull);
      })
      .catch((err) => {
        console.log({ err });
        if (active) setCurrentBull(null);
      })
      .finally(() => {
        if (active) setBullLoading(false);
      });

    return () => {
      active = false;
    };
  }, [ scope.bull ]);

  return (
    <Page disableMinHeight={ scope.segment !== '' && items.scopedBulls.length === 0 }>
      <Stack
        { ...utils.stack.flex.col('center', 'flex-start') }
        sx={ utils.sx.fw }
      >        
        {
          scope.bull === null &&
          <MainTextSearchInput />
        }
        {/* no-scope */}
        {
          scope.segment === '' &&
          <Initial gtMd={ gtMd } />
        }

        <Stack
          { ...utils.stack.flex.col('center', 'flex-start') }
          spacing={ 3 }
          sx={ utils.sx.container }
        >
          {/* segment-page */}
          {
            scope.segment !== '' &&
            scope.breed === null &&
            scope.bull === null &&
            <Breeds />
          }
          {/* breed-page */}
          {
            scope.segment !== '' &&
            scope.breed !== null &&
            scope.bull === null &&
            <BullList />
          }
          {/* bull-page */}
          {
            scope.segment !== '' &&
            scope.bull !== null &&
            bullLoading &&
            <Stack { ...utils.stack.flex.col('center', 'center') } sx={ utils.sx.fw }>
              <CircularProgress size={ 32 } />
            </Stack>
          }
          {
            scope.segment !== '' &&
            scope.bull !== null &&
            !bullLoading &&
            currentBull &&
            <BullDetails bull={ currentBull } />
          }
        </Stack>        
        <Space size={ 3 } />
      </Stack>
    </Page>
  );
};

export default Main;
